// extracted by mini-css-extract-plugin
export default {"calloutText":"CallOut_calloutText__CZdkA"};